/* eslint-disable */
export const getInitialContent = async (locale) => {
  return fetch(`${process.env.REACT_APP_REST_URL}/de.pinuts.schuler.company_location.api/locations/${locale}`).then(rsp => {
    if (rsp.ok) {
      return rsp.json();
    }
    throw ({
      message: 'Error',
      status: rsp.status
    });
  });
};

